import { NgStyle }                                           from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule }     from '@angular/forms';
import { MatCheckboxModule }                                 from '@angular/material/checkbox';
import { UntilDestroy, untilDestroyed }                      from '@ngneat/until-destroy';
import { Store }                                             from '@ngrx/store';
import { User }                                              from '@shared/classes/user';
import { ESTATE_FORMULE }                                    from '@shared/enums/ESTATE_FORMULE';
import { FormuleEnum }                                       from '@shared/enums/formule.enum';
import { BehaviorSubject }                                   from 'rxjs';
import { map, withLatestFrom }                               from 'rxjs/operators';
import { selectUser }                                        from 'src/app/shared/ngrx/store/selectors/user.selector';
import { ITarificationState }                                from 'src/app/shared/ngrx/store/state/tarification/tarification.state';
import { CheckEligiblePipe }                                 from 'src/app/shared/pipe/checkEligible.pipe';
import { SafeHtmlPipe }                                      from 'src/app/shared/pipe/shared/SafeHtml.pipe';
import { CellsHeader }                                       from '../../cells-header';
import { AbstractPrecoOavComponent }                         from '../abstractPreco-oav.component';

@UntilDestroy ()
@Component ({
              selector:        'app-preco-left-column',
              templateUrl:     './preco-left-column.component.html',
              styleUrls:       ['./preco-left-column.component.scss'],
              changeDetection: ChangeDetectionStrategy.OnPush,
              standalone:      true,
              imports:         [
                ReactiveFormsModule,
                MatCheckboxModule,
                NgStyle,
                SafeHtmlPipe,
                CheckEligiblePipe,
              ],
              providers:       [],
            })
export class PrecoLeftColumnComponent extends AbstractPrecoOavComponent implements OnInit {
  @Input ()
  listLeftColumn$: BehaviorSubject<CellsHeader[]>;

  constructor (override _fb: FormBuilder, override _store: Store<ITarificationState>) {
    super (_fb, _store);
  }

  override ngOnInit (): void {
    this.listLeftColumn$.pipe (
      untilDestroyed (this),
      withLatestFrom (
        this._store.select (selectUser),
      ),
      map (([ar, user]: [any, User]) => {
        ar.forEach (m => {
          const control = new FormControl ([ESTATE_FORMULE.CHECKED].includes (m?.isElligible));
          this.formGroup.addControl (m.id, control);
        });
      }),
    ).subscribe ();
  }

  protected readonly FormuleEnum       = FormuleEnum;
}
